import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ActivityCriteriaRequestModel,
  ActivityCriteriaResponseModel,
  CreateActivityRequestModel,
  CreateActivityResponseModel,
  DeleteActivityResponseModel,
  UpdateActivityRequestModel,
  UpdateActivityResponseModel,
} from '@roi/common/models/activity.model';
import { Observable } from 'rxjs';
import { Endpoint } from '../constants/endpoint';
import { TransformTool } from '../tools/transform.tool';

@Injectable({ providedIn: 'root' })
export class ActivityFetch {
  private http = inject(HttpClient);
  public getByCriteria(
    request: ActivityCriteriaRequestModel
  ): Observable<ActivityCriteriaResponseModel> {
    return this.http.get<ActivityCriteriaResponseModel>(
      `${Endpoint.Activity}${TransformTool.ConvertObjectToQueryString(request)}`
    );
  }

  public create(
    request: CreateActivityRequestModel
  ): Observable<CreateActivityResponseModel> {
    return this.http.post<CreateActivityResponseModel>(
      `${Endpoint.Activity}`,
      request
    );
  }
  public update(
    request: UpdateActivityRequestModel
  ): Observable<UpdateActivityResponseModel> {
    return this.http.put<UpdateActivityResponseModel>(
      `${Endpoint.Activity}`,
      request
    );
  }
  public delete(id: string): Observable<DeleteActivityResponseModel> {
    return this.http.delete<DeleteActivityResponseModel>(
      `${Endpoint.Activity}/${id}`
    );
  }
}
